<c-card *transloco="let t">
  <c-card-body class="px-2">

          <c-row>
            <c-col class="col-lg-6 col-12">
                <h1>{{ t('View Your Monitors') }}</h1>
            </c-col>
            <c-col class="col-lg-6 col-12 text-end">


              <c-row class="justify-content-end">

              <c-col xs="auto" >
                <div class="btn-group mb-2" role="group">
                <button *ngIf="okService.hasMonitorAccess('monitors','create')" cButton class="btn btn-success text-white" routerLink="/mgmt/monitor-add"><i class="fa-solid fa-plus"></i> {{ t('Add a Monitor') }}</button>

                <div class="btn-group" *ngIf="okService.isAdmin()">
                  <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import/Export Monitors') }}
                  </button>
                    <ul class="dropdown-menu">
                      <li *ngIf="okService.isGeotab()"><a class="dropdown-item"  routerLink="/mgmt/monitors-import"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import from Geotab') }}</a></li>
                      <li><a class="dropdown-item" routerLink="/mgmt/monitors/monitors-upload"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Upload Monitors') }}</a></li>
                      <li><a class="dropdown-item"  (click)="export()"><i class="fa-solid fa-file-excel"></i> {{ t('Export Monitors') }}</a></li>
                    </ul>
                </div>
                <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
              </div>
              </c-col>
            </c-row>


            </c-col>
          </c-row>
          <c-row>
            <c-col class="col-12">
              <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('monitor_info')">
                <i class="fa-solid fa-circle-info"></i> {{ t('Monitors are the staff that manage OK Alone within a company and are notified if there are any alerts for workers. Monitors use this online dashboard to set up workers and view alerts, reports and shift information.') }}
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('monitor_info')"></button>
              </div>
            </c-col>
          </c-row>

          <c-row>
            <c-col class="col-12 col-lg-6 mb-2">

                  <form cForm class="row row-cols-lg-auto g-2 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
                    <c-col class="col-sm-6">
                      <label cLabel class="visually-hidden" for="search">
                        {{ t('Search') }}
                      </label>
                      <c-input-group>
                        <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                        <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                      </c-input-group>
                    </c-col>

                    <c-col xs="auto">
                      <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                      <button cButton class="btn btn-light text-danger" type="submit" (click)="cancelSearch()" *ngIf="formGroup.value.search" ><i class="fa-solid fa-circle-xmark"></i></button>
                    </c-col>

                    </form>

            </c-col>

            <c-col class="col-12 col-lg-6">


              <c-row class="justify-content-end">
                <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
                  <c-input-group  class="text-end">
                    <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                    <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                      <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto" class="mb-2">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                    <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                      <option value="newest">{{ t('Newest') }}</option>
                      <option value="oldest">{{ t('Oldest') }}</option>
                      <option value="name">{{ t('Name') }}</option>
                    </select>
                  </c-input-group>

                </c-col>
              </c-row>
            </c-col>
          </c-row>


          <c-row *ngIf="monitors">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Monitor') }}</th>
                    <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    <ng-container *ngIf="okService.hasFeature('access')">
                      <th scope="col">{{ t('Is Admin') }}</th>
                      <th scope="col">{{ t('Extended Privacy') }}</th>
                    </ng-container>
                    <th scope="col">{{ t('Contact') }}</th>
                    <th scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let monitor of monitors">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/monitor/{{monitor.id}}" *ngIf="okService.hasMonitorAccess('monitors','view')">
                          <svg cIcon class="me-2" name="cil-pencil"></svg>
                          {{ t('Edit') }}
                        </button>
                      </td>
                      <td>
                        <span><b class="fs-5">{{monitor.name}}</b></span>
                      </td>
                      <td>
                        {{monitor.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{monitor.phone}} <span *ngIf="monitor.phone && monitor.phone2">/</span> {{monitor.phone2}}</span>
                        </div>
                      </td>
                      <ng-container *ngIf="okService.hasFeature('access')">
                        <td>
                          <span *ngIf="monitor.admin">Yes</span><span *ngIf="!monitor.admin">No</span>
                        </td>
                        <td>
                          <span *ngIf="monitor.privacy">Yes</span><span *ngIf="!monitor.privacy">No</span>
                        </td>
                      </ng-container>
                      <td>
                        <div class="small text-medium-emphasis">
                          {{monitor.contact.join(", ")}}
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="monitor.geotab_id" class="badge bg-info text-white fs-6">Geotab</span>
                        <a *ngIf="monitor.ehs_insight_id && okService.isEhsInsight()"
                           class="badge bg-success text-white fs-6 text-decoration-none"
                           [href]="okService.ehsInsightUserUrl(monitor.ehs_insight_id)"
                           target="_blank" rel="noopener noreferrer">EHS Insight</a>
                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>


          <c-row class="justify-content-end">

            <c-col xs="auto" class="mt-2 mx-1" *ngIf="monitors">
              <p class="mt-1" ><b>{{ t('Total Monitors:') }}</b> {{pagination.totalCount}}</p>
            </c-col>

            <c-col xs="auto" class="mt-2" *ngIf="pagination.totalPages>1">
              <c-input-group  class="text-end">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>

          </c-row>

  </c-card-body>
</c-card>
